if (!customElements.get('cart-coupon')) {
  customElements.define(
    'cart-coupon',
    class extends HTMLElement {
      connectedCallback() {
        this.context = this.dataset.context || 'default';
        this.body = this.querySelector('.cart-coupon__body');
        this.results = this.querySelector('.cart-coupon__results');
        this.labelEl = this.querySelector('.cart-coupon__label');

        this.bind();

        // O Liquid nem sempre expõe cart.discount_codes com o carrinho vazio.
        // Buscamos o estado real para garantir que o botão "Remover" apareça
        // mesmo quando não há itens na sacola.
        this.syncFromCart();
      }

      /* Religa os listeners após qualquer re-render do corpo */
      bind() {
        this.input = this.querySelector('.cart-coupon__input');
        this.applyButton = this.querySelector('.cart-coupon__apply');
        this.removeButton = this.querySelector('.cart-coupon__remove');

        if (this.applyButton) {
          this.applyButton.addEventListener('click', () => this.apply());
        }
        if (this.removeButton) {
          this.removeButton.addEventListener('click', () => this.remove());
        }
        if (this.input) {
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.apply();
            }
          });
        }
      }

      formatMoney(cents) {
        if (window.Shopify && window.Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || 'R$ {{amount}}');
        }
        return 'R$ ' + (Math.max(cents, 0) / 100).toFixed(2).replace('.', ',');
      }

      escapeHtml(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
        });
      }

      syncFromCart() {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((r) => r.json())
          .then((cart) => this.renderBody(cart))
          .catch(() => {});
      }

      /**
       * Título do desconto AUTOMÁTICO aplicado ao carrinho, se houver.
       *
       * Descontos automáticos não têm código, então não aparecem em
       * cart.discount_codes. Um desconto automático de PRODUTO (ex.: a promoção
       * de 30% em coleções) fica nos itens, em line_level_discount_allocations;
       * o campo legado `discounts` é usado como fallback. Sem isso, o bloco
       * renderizaria o campo de digitar cupom mesmo com a promoção ativa.
       */
      getAutomaticDiscountTitle(cart) {
        const items = cart.items || [];

        for (let i = 0; i < items.length; i++) {
          const allocations = items[i].line_level_discount_allocations || items[i].discounts || [];
          const first = allocations[0];

          if (first) {
            const title = (first.discount_application && first.discount_application.title) || first.title || '';
            if (title) return title;
          }
        }

        return '';
      }

      /* Redesenha o corpo a partir do estado real do carrinho */
      renderBody(cart) {
        if (!this.body) return;

        const codes = (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
        const code = codes[0] || '';
        const savings = cart.total_discount || 0;

        // Só procuramos desconto automático quando não há código digitado:
        // o código tem prioridade porque é o único que o cliente pode remover.
        const automaticTitle = code ? '' : this.getAutomaticDiscountTitle(cart);
        const displayCode = code || automaticTitle;

        if (displayCode) {
          if (this.labelEl) {
            this.labelEl.textContent = this.context === 'empty' ? 'Cupom ainda aplicado' : 'Cupom de desconto';
          }
          this.body.innerHTML = `
            <div class="cart-coupon__applied">
              <div class="cart-coupon__applied-info">
                <span class="cart-coupon__applied-code">${this.escapeHtml(displayCode)}</span>
                ${savings > 0 ? `<span class="cart-coupon__applied-amount">-${this.formatMoney(savings)}</span>` : ''}
              </div>
              ${code ? '<button type="button" class="cart-coupon__remove">Remover</button>' : ''}
            </div>`;
          this.hidden = false;
        } else if (this.context === 'empty') {
          // sem cupom e carrinho vazio: nada a mostrar
          this.hidden = true;
          this.body.innerHTML = '';
        } else {
          if (this.labelEl) this.labelEl.textContent = 'Cupom de desconto';
          this.body.innerHTML = `
            <div class="cart-coupon__row">
              <input
                type="text"
                class="cart-coupon__input"
                placeholder="Insira o cupom"
                aria-label="Cupom de desconto"
              >
              <button type="button" class="cart-coupon__apply">APLICAR</button>
            </div>`;
          this.hidden = false;
        }

        this.bind();
      }

      showMessage(html, isError) {
        if (!this.results) return;
        this.results.hidden = false;
        this.results.innerHTML = html;
        this.results.classList.toggle('cart-coupon__results--error', !!isError);
      }

      clearMessage() {
        if (!this.results) return;
        this.results.hidden = true;
        this.results.innerHTML = '';
        this.results.classList.remove('cart-coupon__results--error');
      }

      renderDrawer(cart) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        // Mantém o estado vazio coerente — renderContents do tema não trata
        // a classe is-empty que está no <cart-drawer> deste tema.
        if (typeof cart.item_count === 'number') {
          cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
        }

        if (cartDrawer.renderContents && cart.sections) {
          cartDrawer.renderContents(cart);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      async apply() {
        if (!this.input) return;
        const code = this.input.value.trim();

        if (!code) {
          this.showMessage('Digite um código de cupom.', true);
          return;
        }

        this.applyButton.disabled = true;
        this.showMessage('Aplicando cupom...', false);

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code, sections: 'cart-drawer,cart-icon-bubble' }),
          });

          const cart = await response.json();
          const found = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());

          if (found && found.applicable) {
            this.clearMessage();
            this.renderDrawer(cart);
          } else {
            this.showMessage('Cupom inválido ou expirado.', true);
            this.applyButton.disabled = false;
          }
        } catch (error) {
          this.showMessage('Não foi possível aplicar o cupom agora. Tente novamente.', true);
          this.applyButton.disabled = false;
        }
      }

      async remove() {
        if (!this.removeButton) return;
        this.removeButton.disabled = true;
        this.showMessage('Removendo cupom...', false);

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '', sections: 'cart-drawer,cart-icon-bubble' }),
          });

          const cart = await response.json();
          this.clearMessage();

          // Com o carrinho vazio o drawer não re-renderiza este bloco,
          // então atualizamos o corpo localmente antes de propagar.
          this.renderBody(cart);
          this.renderDrawer(cart);
        } catch (error) {
          this.showMessage('Não foi possível remover o cupom agora.', true);
          this.removeButton.disabled = false;
        }
      }
    }
  );
}
